<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
    ref="baseDelete"
  >
    <p> Você tem certeza que deseja deletar o plano de contas <b>{{this.entry.text}}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "../../shared/base_delete.vue";

export default {
 data () {
  return {
    error: null,
    loading: true,
    formErrors: [],
  }
},
components: {
  BaseDelete: BaseDelete
},
props: {
  entry: Object,
  modelNameSingular: String,
},
 methods: {
   destroyServerEntry: function(chartOfAccount) {
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: DESTROY_CHAR_OF_ACCOUNT_MUTATION,
          variables: {
            id: chartOfAccount.id,
          }
        })
        .then(response => {
          // console.log(response);
          var errors = response.data.destroyChartOfAccount.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$emit("entry-destroyed");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const DESTROY_CHAR_OF_ACCOUNT_MUTATION = gql `
  mutation($id: ID!) {
    destroyChartOfAccount(id: $id) {
      chart {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>